export default "__VITE_ASSET__Cegx9WAW__"